import { DataQueryKey, UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';
import { FindGroupedChatsParams } from './chats.types';

export const getAllChatsNotificationsKey = (): UseDataQuery['queryKey'] => [
  DataQueryKey.CHAT_NOTIFICATIONS,
  undefined,
];

export const getFindGroupedChatsKey = (
  params: FindGroupedChatsParams,
): UseDataQuery['queryKey'] => [DataQueryKey.FIND_GROUPED_CHATS, undefined, params];

export const getChatToUpdateKey = (chatId: string): UseDataQuery['queryKey'] => [
  DataQueryKey.CHAT_TO_UPDATE,
  chatId,
];
